import { render } from "./GroceryList.vue?vue&type=template&id=94061afe&scoped=true"
import script from "./GroceryList.vue?vue&type=script&lang=js"
export * from "./GroceryList.vue?vue&type=script&lang=js"

import "./GroceryList.vue?vue&type=style&index=0&id=94061afe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94061afe"]])

export default __exports__